import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./index.scss";
import { useLanguage } from "../../../contexts/LanguageContext";
import { getTranslation } from "../../../translations";

const Footer = () => {
  const { language } = useLanguage();

  return (
    <footer className="custom-footer py-5">
      <Container>
        <Row className="justify-content-center text-start">
          <Col md={3}>
            <h6>{getTranslation(language, "home")}</h6>
            <ul>
              <li>
                <a href="/#filiales">{getTranslation(language, "filiales")}</a>
              </li>
              <li>
                <a href="/#contact">{getTranslation(language, "contact")}</a>
              </li>
            </ul>
          </Col>

          <Col md={3}>
            <h6>{getTranslation(language, "msitCorporate")}</h6>
            <ul>
              <li>
                <a href="#">{getTranslation(language, "msitAdvisory")}</a>
              </li>
              <li>
                <a href="#">{getTranslation(language, "buzzTrack")}</a>
              </li>
              <li>
                <a href="#">{getTranslation(language, "spotIn")}</a>
              </li>
            </ul>
          </Col>
        </Row>

        <Row className="footer-bottom align-items-center mt-4">
          <Col md={6} className="text-md-start text-center">
            <p>{getTranslation(language, "allRightsReserved")}</p>
          </Col>

          <Col md={6} className="text-md-end text-center">
            <a href="/privacy-policy" className="me-4">
              {getTranslation(language, "privacyPolicy")}
            </a>
            <a href="/cookies-policy">
              {getTranslation(language, "cookiesPolicy")}
            </a>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
